jQuery(document).ready(function () {

	/**
	 * search custom post types and users
	 */

	// main
	search(jQuery('.js-search-all'), '.js-search-panel', 'search_all');

	function search(inputSearchField, searchPanel, fn) {
		// variables
		var minQLen = 2; // minimum query length before searching
		var lastValue;
		var searchValue;
		var $inputSearchField = inputSearchField;
		var lastXhr;

		// Triggers search on input change
		$inputSearchField.on('change keyup', function (e) {

			searchValue = $inputSearchField.val(); // Fetch value

			// checks if it is less then the minimun length before search
			if (searchValue.length < minQLen) {
				return;
			}

			// Same value as last, do no new search
			if (searchValue === lastValue) {
				return;
			}
			if(lastXhr && lastXhr.readyState < 4) { //if previous request hasn't finished yet, abort that one and only do this new one (to prevent timing issues)
				lastXhr.abort();
			}
			lastXhr = fetchBySearch(inputSearchField, searchValue, fn, searchPanel);
			lastValue = searchValue;

		});
	}


	function fetchBySearch(input, searchTerm, searchFunction, searchPanel) {
		return jQuery.ajax({
			url: ajax.ajaxurl,
			dataType: 'html',
			type: 'POST',
			data: {
				'search': searchTerm,
				'action': searchFunction
			},
			success: function (data) {
				jQuery(searchPanel).replaceWith(data);
				$('#hdnposttypesearch').val($('.js-button-search-more').data('posttype'));
			}
		});
	}


});
